import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=6b505c6d"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=6b505c6d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports